



















import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';

const cssPrefix = 'sw-announcement-banner';

@Component
export default class SwAnnouncementBanner extends SwExtendedVue {
  cssPrefix = cssPrefix;
  visible: boolean = false;

  @Prop({ type: String, default: '' })
  eolDate: string;

  @Prop({ type: Boolean, default: false })
  showBanner: boolean;

  @Watch('showBanner', { immediate: true })
  onShowBannerChanged(val: boolean) {

    this.visible = val;
  }

  close() {
    this.visible = false;
    this.$store.commit('resetShowAppEOLBanner');
  }
}
